"use client";
import dynamic from "next/dynamic";
import { useLazyLoad, LAZY_LOAD_CONFIGS } from "@hooks/useLazyLoad";

const MMGallery = dynamic(
  () => import("./index").then((mod) => mod.MMGallery),
  {
    ssr: false,
    loading: () => <div className="gallery-skeleton">Loading gallery...</div>,
  }
);

export default function MMGalleryClient(props: any) {
  const shouldLoad = useLazyLoad(LAZY_LOAD_CONFIGS.GALLERY);

  if (!shouldLoad) {
    return <div>Image Gallery</div>;
  }

  return <MMGallery {...props} />;
}
